<template>
  <div>
    <h3>Paramètres > Commune </h3>
    <br>

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5" >
      <v-card-title>
        <h6 class="primary--text">Liste des communes</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('export municipalities')">
          <export-excel
            :data = "communes"
            name = "Communes.xls"
            :export-fields ="communes_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create municipalities')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
          </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      v-model="editedItem.department_id"
                      :items="departements"
                      item-text="name"
                      item-value="id"
                      label="Département"
                      clearable
                      solo></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.name" label="Nom de la commune" solo></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" text @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" text @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher une commune"
          single-line
          solo
          hide-details>
        </v-text-field>
      </v-card-title>
    </v-card>
  <v-data-table
    :headers="headers"
    :items="communes"
    :loading="loading"
    loading-text="Loading..."
    sort-by="name"
    :search="search"
    class="elevation-1">
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        v-if="$can('edit municipalities')">
        mdi-pencil-outline
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
        v-if="$can('delete municipalities')">
        mdi-trash-can-outline
      </v-icon>
    </template>
  </v-data-table>

  <v-layout row justify-center>
    <v-dialog
      v-model="dialog_deletion"
      max-width="290">
      <v-card>
        <v-card-title class="headline">Suppression</v-card-title>
        <v-card-text class="text-center">
         Etes-vous sûr de vouloir supprimer cette commune ?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="orange"
            rounded
            @click="dialog_deletion = false">
             <span class="white-couleur">Non</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            rounded
            @click="delCommune()">
            Oui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-municipality',
  mixins: [Permissions],
  data: () => ({
    del_commune: null,
    del_index: null,
    search: '',
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
          { text: 'Commune', value: 'name' },
          { text: 'Département', value: 'department.name' },
          { text: 'Actions', value: 'action', sortable: false }
        ],
    communes_fields : {
          "Commune": "name",
          "Département": "department.name",
      },
    snackbar: false,
    loading: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      department_id: null,
    },
    defaultItem: {
      name: '',
      department_id: null,
    },

  }),

  created () {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    communes () { return this.$store.getters.municipalities; },
    departements () { return this.$store.getters.departments; },
    formTitle () {
        return this.editedIndex === -1 ? 'Nouvelle commune' : 'Editer la commune'
      },
  },

  watch: {
      dialog (val) {
        val || this.close()
      },
    },

  methods: {
    fetchUtils () {
      this.$store.dispatch("fetchMunicipalities");
      this.$store.dispatch("fetchDepartments");
    },

    editItem (item) {
      this.editedIndex = this.communes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem (item) {
      this.del_index = this.communes.indexOf(item);
      this.dialog_deletion = true;
      this.del_commune = item;
    },

    close () {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateMunicipality", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Commune éditée avec succès !";
      }
      else {
        await this.$store.dispatch("createMunicipality", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Commune enregistrée avec succès !";
      }
      this.close();
    },

    async delCommune(){
      await this.$store.dispatch("deleteMunicipality", this.del_commune);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Commune supprimée avec succès !";
    },

  }
};
</script>

<style scoped>
.white-couleur{
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/municipality.vue